export const getJobCount = state => state.exportProjectImages.jobCount;



// WEBPACK FOOTER //
// ./src/selectors/exportProjectImagesSelectors.js